export function scrollPageTo({ top = 0, behavior = "auto" } = {}) {
	const html = document.documentElement;
	const body = document.body;
	const options = { top, left: 0, behavior };

	if (behavior === "smooth") {
		window.scrollTo(options);
		html.scrollTo(options);
		body.scrollTo(options);
		return;
	}

	const prevHtml = html.style.scrollBehavior;
	const prevBody = body.style.scrollBehavior;
	html.style.scrollBehavior = "auto";
	body.style.scrollBehavior = "auto";
	window.scrollTo(0, top);
	html.scrollTo(0, top);
	body.scrollTo(0, top);
	html.scrollTop = top;
	body.scrollTop = top;
	html.style.scrollBehavior = prevHtml;
	body.style.scrollBehavior = prevBody;
}
